import { Table as TableCommon, TableProps, TableDataType } from '@arnold/common';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EmptyTable } from '@arnold/common/lib/assets/images/EmptyTable.svg';

export const Table = <T extends TableDataType>(props: Omit<TableProps<T>, 'labels'>): JSX.Element => {
  const { t } = useTranslation('table');

  return <TableCommon {...props} labels={{ emptyTableLabel: t('emptyTableLabel') }} emptyImage={<EmptyTable />} />;
};
